import OSS from 'ali-oss';
import gql from 'graphql-tag';
import Message from '@/components/message';

class Upload {
  private client?: OSS;
  private path = '';
  private cdn = '';
  private expiration: Date = new Date();

  uploading = false;

  async retrieveToken() {
    if (this.expiration > new Date() && this.client) {
      return;
    }

    try {
      const res = await window.$getClemanClient().apollo.query({
        query: gql`
          query uploadToken {
            currentUser {
              upload {
                token {
                  cdn
                  bucket
                  region
                  expiration
                  accessKeyId
                  accessKeySecret
                  stsToken
                  path
                }
              }
            }
          }
        `
      });

      this.client = new OSS(res.data.currentUser.upload.token);
      this.path = res.data.currentUser.upload.token.path;
      this.cdn = res.data.currentUser.upload.token.cdn;
      this.expiration = new Date(res.data.currentUser.upload.token.expiration);
    } catch (err) {
      Message.Message.error((err as any).message);
      throw err;
    }
  }

  async put(file: File, onProgress?: (progress: number) => void): Promise<string> {
    if (this.uploading) {
      Message.Message.error({ content: '请等待其他上传完成，再执行该上传', time: 3000 });
      return '';
    }

    await this.retrieveToken();

    const name = this.path + '/' + file.name;

    try {
      this.uploading = true;
      const res = await this.client!.multipartUpload(name, file, {
        progress: (p: number) => {
          onProgress?.(p);
        }
      });

      if (res?.res?.status !== 200) {
        throw new Error('上传失败');
      }

      return this.cdn + '/' + name;
    } catch (error) {
      Message.Message.error({ time: 3000, content: `上传失败，${(error as any).message}` });
      throw error;
    } finally {
      this.uploading = false;
    }
  }
}

export default new Upload();
